import React from 'react';
import {
  AppBar,
  Toolbar,
  Grid,
  IconButton,
  Button,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom';
import { removeToken } from '../utils/subscriptionsService';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import { loadToken } from '../localStorage';
import GAR_logo from '../img/GAR_logo.png';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
  },
  isiLogo: {
    padding: `0px ${theme.spacing(1)}px`,
    fontSize: '0.8rem',
    height: '3rem',
  },
  searchInput: {
    opacity: '0.6',
    padding: `0px ${theme.spacing(1)}px`,
    fontSize: '0.8rem',
    '&:hover': {
      backgroundColor: '#f2f2f2',
    },
    '& .MuiSvgIcon-root': {
      marginRight: theme.spacing(1),
    },
  },
  titleHeader: {
    textAlign: 'center',
    color: '#333',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${theme.spacing(0.5)}px 0`,
    '& .MuiTypography-subtitle2': {
      opacity: '0.6',
    },
  },
  title: {
    lineHeight: 1.15,
    marginBottom: theme.spacing(0.75),
  },
  nav: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  navButton: {
    minWidth: 120,
  },
  logoutIcon: {
    display: 'flex',
    '& .MuiIconButton-root': {
      'margin-left': 'auto',
    },
  },
}));

export default function Header() {
  const classes = useStyles();
  let history = useHistory();
  const location = useLocation();
  // const token = useSelector((state) => state.token);
  // const token = JSON.parse(localStorage.getItem('token'));

  const token = loadToken();

  const logout = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_URL_API}/users/logoutAll`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );
    removeToken(res, history);

    // dispatch(removeToken());
    localStorage.removeItem('token');
    history.replace('/');
  };

  return (
    <AppBar position='static' className={classes.root}>
      <Toolbar>
        {token && (
          <Grid container alignItems='center'>
            <Grid item sm>
              <img src={GAR_logo} alt='logo' className={classes.isiLogo} />
            </Grid>
            <Grid item sm className={classes.titleHeader}>
              <Typography variant='h6' component='div' className={classes.title}>
                Gérer vos abonnements ISIaccess
              </Typography>
              <div className={classes.nav}>
                <Button
                  component={RouterLink}
                  to='/abonnements'
                  color='primary'
                  variant={location.pathname === '/abonnements' ? 'contained' : 'text'}
                  size='small'
                  className={classes.navButton}
                >
                  Abonnements
                </Button>
                <Button
                  component={RouterLink}
                  to='/ressources'
                  color='primary'
                  variant={location.pathname === '/ressources' ? 'contained' : 'text'}
                  size='small'
                  className={classes.navButton}
                >
                  Ressources
                </Button>
              </div>
            </Grid>
            <Grid item sm className={classes.logoutIcon}>
              <IconButton onClick={logout}>
                <PowerSettingsNewIcon fontSize='small' />
              </IconButton>
            </Grid>
          </Grid>
        )}
      </Toolbar>
    </AppBar>
  );
}
